import React from 'react'
import { IconContext } from 'react-icons'
import { IconTooltip as Tooltip } from '../Tooltip'
import { FaCompressArrowsAlt, FaExpandArrowsAlt } from 'react-icons/fa'

export default ({ name, isExpanded, setIsExpanded }) => {
    return (
        <div
            className={`panelHeaderIconDiv`}
            data-tooltip-content={`${isExpanded ? `Collapse` : `Expand to Full Screen`}`}
            data-tooltip-id={`${name}-expanded-${isExpanded}`}
            onClick={() => setIsExpanded(current => !current)}
        >
            {isExpanded ? <FaCompressArrowsAlt /> : <FaExpandArrowsAlt />}
            <Tooltip id={`${name}-expanded-${isExpanded}`} />
        </div>
    )
}
